// Shopify Lazy Loading Script - Complete with Loader

(function() {
    'use strict';

    // Configuration
    var lazy_css = [];
    var lazy_js = [];
    var lazyImages = [];

    // Track loaded elements
    var imageCount = 0;
    var maxImages = 20;

    // Debounce utility
    function _debounce(func, delay) {
        delay = delay || 300;
        var timeout;
        return function() {
            var context = this;
            var args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, delay);
        };
    }

    // Load single image
    function loadImage(img) {
        if (img.hasAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
            img.classList.add('lazy-loaded');
        }
        if (img.hasAttribute('data-srcset')) {
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
        }
    }

    // Load single iframe
    function loadIframe(iframe) {
        if (iframe.hasAttribute('data-src')) {
            iframe.src = iframe.getAttribute('data-src');
            iframe.removeAttribute('data-src');
            iframe.classList.add('lazy-loaded');
        }
    }

    // Load CSS
    function loadCSS(link) {
        if (link.hasAttribute('data-href')) {
            link.href = link.getAttribute('data-href');
            link.removeAttribute('data-href');
        }
    }

    // Load Script
    function loadScript(script) {
        if (script.hasAttribute('data-src')) {
            var newScript = document.createElement('script');
            newScript.src = script.getAttribute('data-src');
            newScript.type = 'text/javascript';
            
            // Copy attributes
            Array.from(script.attributes).forEach(function(attr) {
                if (attr.name !== 'data-src' && attr.name !== 'type') {
                    newScript.setAttribute(attr.name, attr.value);
                }
            });
            
            script.parentNode.replaceChild(newScript, script);
        }
    }

    // Load Video
    function loadVideo(video) {
        // Load video src
        if (video.hasAttribute('data-src')) {
            video.src = video.getAttribute('data-src');
            video.removeAttribute('data-src');
        }
        
        // Load poster image
        if (video.hasAttribute('data-poster')) {
            video.poster = video.getAttribute('data-poster');
            video.removeAttribute('data-poster');
        }
        
        // Load source elements
        var sources = video.querySelectorAll('source[data-src]');
        sources.forEach(function(source) {
            source.src = source.getAttribute('data-src');
            source.removeAttribute('data-src');
        });
        
        // Reload video to apply new sources
        if (sources.length > 0) {
            video.load();
        }
        
        video.classList.add('lazy-loaded');
    }

    // Intersection Observer for lazy loading
    var lazyLoadObserver;
    
    if ('IntersectionObserver' in window) {
        lazyLoadObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var element = entry.target;
                    
                    if (element.tagName === 'IMG') {
                        loadImage(element);
                    } else if (element.tagName === 'IFRAME') {
                        loadIframe(element);
                    } else if (element.tagName === 'LINK') {
                        loadCSS(element);
                    } else if (element.tagName === 'VIDEO') {
                        loadVideo(element);
                    }
                    
                    lazyLoadObserver.unobserve(element);
                }
            });
        }, {
            rootMargin: '50px 0px', // Start loading 50px before element enters viewport
            threshold: 0.01
        });
    }

    // Fallback for browsers without IntersectionObserver
    function lazyLoadFallback() {
        var lazyElements = document.querySelectorAll('[data-src], [data-href], [data-poster]');
        
        lazyElements.forEach(function(element) {
            var rect = element.getBoundingClientRect();
            var isVisible = (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 200 &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
            
            if (isVisible) {
                if (element.tagName === 'IMG') {
                    loadImage(element);
                } else if (element.tagName === 'IFRAME') {
                    loadIframe(element);
                } else if (element.tagName === 'LINK') {
                    loadCSS(element);
                } else if (element.tagName === 'VIDEO') {
                    loadVideo(element);
                }
            }
        });
    }

    // Observe or load element
    function observeElement(element) {
        if (lazyLoadObserver) {
            lazyLoadObserver.observe(element);
        } else {
            // Fallback: load after a short delay
            setTimeout(function() {
                if (element.tagName === 'IMG') {
                    loadImage(element);
                } else if (element.tagName === 'IFRAME') {
                    loadIframe(element);
                } else if (element.tagName === 'LINK') {
                    loadCSS(element);
                } else if (element.tagName === 'VIDEO') {
                    loadVideo(element);
                }
            }, 100);
        }
    }

    // Load all lazy elements immediately (emergency function)
    function loadAllLazy() {
        var images = document.querySelectorAll('img[data-src]');
        var iframes = document.querySelectorAll('iframe[data-src]');
        var links = document.querySelectorAll('link[data-href]');
        var videos = document.querySelectorAll('video[data-src], video[data-poster]');
        
        images.forEach(loadImage);
        iframes.forEach(loadIframe);
        links.forEach(loadCSS);
        videos.forEach(loadVideo);
    }

    // Process existing elements
    function initLazyLoading() {
        // Find all elements with data-src or data-href
        var lazyImages = document.querySelectorAll('img[data-src]');
        var lazyIframes = document.querySelectorAll('iframe[data-src]');
        var lazyLinks = document.querySelectorAll('link[data-href]');
        var lazyScripts = document.querySelectorAll('script[data-src]');
        var lazyVideos = document.querySelectorAll('video[data-src], video[data-poster], video source[data-src]');
        
        // Observe images
        lazyImages.forEach(function(img) {
            // Add loading attribute for native lazy loading support
            if (!img.hasAttribute('loading')) {
                img.setAttribute('loading', 'lazy');
            }
            observeElement(img);
        });
        
        // Observe iframes
        lazyIframes.forEach(function(iframe) {
            if (!iframe.hasAttribute('loading')) {
                iframe.setAttribute('loading', 'lazy');
            }
            observeElement(iframe);
        });
        
        // Observe links
        lazyLinks.forEach(function(link) {
            observeElement(link);
        });
        
        // Observe videos
        lazyVideos.forEach(function(video) {
            // If it's a source element, observe its parent video
            if (video.tagName === 'SOURCE') {
                var parentVideo = video.closest('video');
                if (parentVideo && !parentVideo.classList.contains('lazy-observed')) {
                    parentVideo.classList.add('lazy-observed');
                    observeElement(parentVideo);
                }
            } else {
                if (!video.classList.contains('lazy-observed')) {
                    video.classList.add('lazy-observed');
                    observeElement(video);
                }
            }
        });
        
        // Load scripts when document is ready
        if (document.readyState === 'complete') {
            lazyScripts.forEach(loadScript);
        } else {
            window.addEventListener('load', function() {
                lazyScripts.forEach(loadScript);
            });
        }
    }

    // MutationObserver for dynamically added elements
    if ('MutationObserver' in window) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Check if node itself needs lazy loading
                        if (node.hasAttribute && node.hasAttribute('data-src')) {
                            observeElement(node);
                        }
                        
                        // Check child elements
                        if (node.querySelectorAll) {
                            var lazyElements = node.querySelectorAll('[data-src], [data-href], [data-poster]');
                            lazyElements.forEach(observeElement);
                        }
                    }
                });
            });
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLazyLoading);
    } else {
        initLazyLoading();
    }

    // Fallback scroll listener if IntersectionObserver not available
    if (!lazyLoadObserver) {
        var scrollHandler = _debounce(lazyLoadFallback, 200);
        window.addEventListener('scroll', scrollHandler);
        window.addEventListener('resize', scrollHandler);
        window.addEventListener('orientationchange', scrollHandler);
    }

    // Force load all on page load complete (safety net)
    window.addEventListener('load', function() {
        setTimeout(function() {
            var stillLazy = document.querySelectorAll('[data-src]:not(.lazy-loaded)');
            if (stillLazy.length > 0) {
                console.log('Force loading remaining lazy elements:', stillLazy.length);
                stillLazy.forEach(function(el) {
                    if (el.tagName === 'IMG') loadImage(el);
                    else if (el.tagName === 'IFRAME') loadIframe(el);
                });
            }
        }, 1000);
    });

    // Expose global function for manual loading
    window.loadAllLazy = loadAllLazy;
    window.__lazyLoadActive = true;

})();